var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3856 13.0491L9.44366 1.16281C9.18652 0.648407 8.66956 0.328857 8.09452 0.328857C7.51949 0.328857 7.00253 0.648407 6.74536 1.16281L0.803439 13.0491C0.567924 13.5202 0.592637 14.0689 0.869514 14.5169C1.14636 14.9648 1.62601 15.2323 2.15255 15.2323H14.0365C14.563 15.2323 15.0427 14.9648 15.3195 14.5169C15.5964 14.0689 15.6211 13.5202 15.3856 13.0491ZM14.3291 13.9048C14.2988 13.9538 14.2095 14.0679 14.0365 14.0679H2.15255C1.97947 14.0679 1.89025 13.9538 1.85992 13.9048C1.82959 13.8557 1.76736 13.7247 1.84484 13.5697L7.78679 1.68344C7.87263 1.51173 8.0306 1.49319 8.09452 1.49319C8.15845 1.49319 8.31642 1.51173 8.40226 1.68344L14.3442 13.5698C14.4217 13.7247 14.3594 13.8557 14.3291 13.9048Z",
    fill: "#F69D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09462 5.57056C7.77309 5.57056 7.51245 5.83119 7.51245 6.15272V9.82386C7.51245 10.1454 7.77309 10.406 8.09462 10.406C8.41614 10.406 8.67675 10.1454 8.67678 9.82389V6.15272C8.67678 5.83119 8.41614 5.57056 8.09462 5.57056Z",
    fill: "#F69D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09427 12.6475C8.52831 12.6475 8.88018 12.2957 8.88018 11.8616C8.88018 11.4276 8.52831 11.0757 8.09427 11.0757C7.66022 11.0757 7.30835 11.4276 7.30835 11.8616C7.30835 12.2957 7.66022 12.6475 8.09427 12.6475Z",
    fill: "#F69D5C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.9034,
    height: 14.9034,
    fill: "white",
    transform: "translate(0.642822 0.328857)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.45aad9ed26d329b3cc0404af42d006d9.svg";
export { ForwardRef as ReactComponent };